import { getInspectionResultOptionsFilter } from '@/constants/options/inspection-result.option';
import { getPeriodTypeOptionsFilter } from '@/constants/options/period-type.option';
import { getReportTypeOptionsFilter } from '@/constants/options/report-type.option';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => {
    return [
        {
            key: [
                {
                    key: 'code',
                    trans: 'code.qualityManagement',
                    defaultOperator: 'like',
                },
            ],
            type: 'input',
            value: [],
        },
        {
            key: [
                {
                    key: 'inspectionDate',
                    trans: 'inspectionDate',
                    defaultOperator: '=',
                },
            ],
            type: 'date',
            value: [],
        },
        {
            key: [
                {
                    key: 'periodType',
                    trans: 'periodType.qualityManagement',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getPeriodTypeOptionsFilter(true),
        },
        {
            key: [
                {
                    key: 'inspectionResult',
                    trans: 'inspectionResult.qualityManagement',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getInspectionResultOptionsFilter(true),
        },
        {
            key: [
                {
                    key: 'reportType',
                    trans: 'reportType.qualityManagement',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getReportTypeOptionsFilter(true),
        },
    ];
};
